export enum URLSearchParamsEnum {
    ProductUpselling = 'productUpselling',
    ShowDiscover = 'showDiscover',
    ShareIdentifier = 'shareIdentifier',
}
